/**
 * Central axios configuration module.
 * This module must be imported once during app bootstrap (in index.jsx).
 * It configures global defaults for any bare `axios` imports.
 */
import axios from 'axios'

// Configure axios to include credentials (cookies) with all requests.
// This ensures consistent behavior across all API calls, including those
// using bare `axios` imports in legacy code. New code should prefer
// using `axiosInstance` from ./axiosInstance.js for explicit configuration.
axios.defaults.withCredentials = true

// Optional: Add any other global axios configuration here as needed
// e.g., interceptors, timeouts, default headers, etc.

export default undefined // No exports; this module is imported for side effects only
